import React from 'react';
import PropTypes from 'prop-types';
import { PaperClipOutlined } from '@ant-design/icons';
import isEmpty from 'utils/is-empty';

const downloadUrl = process.env.REACT_APP_DOWNLOAD_URL;

const FileListItem = ({ file }) => {
  const { id, filename } = file;
  // console.log(file.id);

  if (isEmpty(file)) {
    return '';
  }

  return (
    <a rel="noreferrer" href={`${downloadUrl}${id}`} target="_blank">
      <PaperClipOutlined /> {filename}
    </a>
  );
};

FileListItem.defaultProps = {
  file: {},
};

FileListItem.propTypes = {
  file: PropTypes.shape({
    id: PropTypes.string.isRequired,
    filename: PropTypes.string.isRequired,
  }).isRequired,
};

export default FileListItem;
